import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import {
  DescriptionOutputSnapshotKey,
  InputDataPageType,
} from '../schema/types';
import { InputDataUrl } from './InputDataUrl';
import { InputDataPageSchema } from '../schema/InputDataSchema';

const getDescriptionOutputSnapshot = (params?: DescriptionOutputSnapshotKey) =>
  apiClient
    .get<InputDataPageType>(expand(InputDataUrl.OUTPUT_SNAPSHOT, params))
    .then((response) => InputDataPageSchema.parse(response.data));

export const useDescriptionOutputSnapshotQuery = createApiQueryHook(
  ['useDescriptionOutputSnapshot'],
  getDescriptionOutputSnapshot,
);
